/**
 * 枚举类
 */
export class MiniRate {

    size = 0;
    //arch_miniRate id rate fixRate feeLowest feeHighest
    add (id, rate, fixRate, feeLowest, feeHighest, payChannelCode, payWayCode, payModeCode, rateType ) {
        this[id] = {rate, fixRate, feeLowest, feeHighest};
        this[payChannelCode+'-'+payWayCode+'-'+payModeCode+'-'+rateType] = {rate, fixRate, feeLowest, feeHighest};
        this.size++;
        return this
    }

}